import { render, staticRenderFns } from "./Button-Form-Set.vue?vue&type=template&id=ba4e6ece&"
import script from "./Button-Form-Set.vue?vue&type=script&lang=js&"
export * from "./Button-Form-Set.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports